import { CreateAccountResponse, LoginResponse, RessetPasswordResponse, User } from "features/user/model/types/user"

import packageJson from "../../../package.json"
import { getCurrentAppConfig } from "../config/appConfig"

import { request } from "./request"


export type UserLinksResponse = {
  _links: {
    self: {
      href: string
    },
    user: {
      href: string
      templated: boolean
    },
    current_user: {
      href: string
    }
  }
}

export const userApi = {
  resendCode: (data: { login: string }) => {
    return request<LoginResponse>('POST', `/api/2/accounts/resend_message_for_approve/`, data, { host: getCurrentAppConfig().authApi })
  },
  updateUserData: (userId: number, data: Record<string, any>) => {
    return request('PATCH', `/api/2/users/${userId}`, data)
  },
  patchUserData: (userId: number, data: Record<string, any>) => {
    return request('PATCH', `/api/2/users/${userId}`, data)
  },
  login: (data: { email: string, password: string, remember_me: boolean }) => {
    return request<LoginResponse>('POST', `/api/2/accounts/login`, data, { host: getCurrentAppConfig().authApi })
  },
  googleAuth: (data: { jwt_token: string, state }) => {
    return request<LoginResponse>("POST", `/api/2/accounts/google_confirm`, data, { host: getCurrentAppConfig().authApi })
  },
  createAccount: (data: { email: string, password: string, name: string }) => {
    return request<CreateAccountResponse>('POST', `/api/2/accounts/create`, data, { host: getCurrentAppConfig().authApi })
  },
  approveSignup: (hash: string) => {
    return request<LoginResponse>('POST', `/api/2/accounts/approve`, { hash }, { host: getCurrentAppConfig().authApi })
  },
  resendMessageForApprove: (login: string): Promise<void> => {
    return request<void>('POST', `/api/2/accounts/resend_message_for_approve`, { login }, { host: getCurrentAppConfig().authApi })
  },
  ressetPassword: (login: string) => {
    return request<RessetPasswordResponse>('POST', `/api/2/accounts/recover_lost_password`, { login: 'email:' + login }, { host: getCurrentAppConfig().authApi })
  },
  getUserLinks: () => {
    return request<UserLinksResponse>('GET', '/api/2/users')
  },
  getUserData: () => {
    return request<User>('GET', '/api/2/accounts/me', undefined, { host: getCurrentAppConfig().authApi })
  },
  logout: (token: string, userId: number) => {
    return request('DELETE', `/api/2/users/${userId}/tokens/${token}`)
  },
  changePassword: (userId: number, data: { password: string, current_password: string }) => {
    return request('PATCH', `/api/2/users/${userId}`, data)
  },
  sendInviteToFamily: (userId: number, familyId: string, email: string) => {
    return request('POST', `/api/2/users/${userId}/families/${familyId}/invites`, { phone_or_email: email })
  },
  getOffers: ({ ...params }) => {
    const url = "/api/2/offers"
    return request("GET", url, params, { host: getCurrentAppConfig().authApi })
  },
  getOffer: (offerId: string) => {
    const url = `/api/2/offers/${offerId}`
    return request("GET", url, undefined, { host: getCurrentAppConfig().authApi })
  },
  
  getContentOffer: async (linkContent: string) => {
    const urlObj = new URL(linkContent)
    const relativePath = urlObj.pathname + urlObj.search

    return request("GET", relativePath, undefined, {
      headers: { "Accept": "text/html" },
      host: getCurrentAppConfig().authApi,
    })
  },
  getUserSettings: (userId: number) => {
    return request('GET', `/api/2/users/${userId}/settings_values`)
  },
  updateUserSetting: (userId: number, settingKey:string, data:any) => {
    return request('PATCH', `/api/3/users/${userId}/settings/${settingKey}/value`, data)
  },
  getContentTypes: (userId) => {
    return request('GET', `/api/2/users/${userId}/photos/supported_formats/`)
  },
  getAppVersion() {
    return `v${packageJson.version}`
  },
  getUserDataById: (userId: number) => {
    return request('GET', `/api/2/users/${userId}`)
  }
}

